import { CommonModule } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DelonACLModule } from '@delon/acl';
import { DelonFormModule } from '@delon/form';
import { AlainThemeModule } from '@delon/theme';
import { TranslateModule } from '@ngx-translate/core';

import { itcoreModule } from './itcore/itcore.module';
import { SHARED_DELON_MODULES } from './shared-delon.module';
import { SHARED_ZORRO_MODULES } from './shared-zorro.module';

import { AdSearchComponent } from './components/ad-search/ad-search.component';
import { AdSearchModalComponent } from './components/ad-search/modal/modal.component';
import { FilterGroupComponent } from './components/filter-group/filter-group.component';
import { FilterRuleComponent } from './components/filter-group/filter-rule.component';
import { FunctionViewComponent } from './components/function-view/function-view.component';
import { ModalRoleTreeComponent } from './components/modal-tree/modal-role-tree.component';
import { ModalTreeComponent } from './components/modal-tree/modal-tree.component';
import { ItcoreImportComponent } from './components/common/Import/import.component';
import { PayPwdComponent } from './components/common/paypwd/paypwd.component';
import { TooltipComponent } from './components/common/tooltip/tooltip.component';
import { ExponentialStrengthPipe } from '../pipes/getPipe';
import { FileListShowComponent } from './components/common/img/file-list-show.component';
import { SeDepartmentViewComponent } from './components/function-view/sedepartment-view.component';
// #region third libs
// import { NgxTinymceModule } from 'ngx-tinymce';
// import { UEditorModule } from 'ngx-ueditor';

const THIRDMODULES: Array<Type<any>> = [itcoreModule];
// #endregion

// #region your componets & directives
const COMPONENTS: Array<Type<any>> = [
  AdSearchComponent,
  AdSearchModalComponent,
  FilterGroupComponent,
  FilterRuleComponent,
  FunctionViewComponent,
  ModalRoleTreeComponent,
  ModalTreeComponent,
  ItcoreImportComponent,
  PayPwdComponent,
  TooltipComponent,
  ExponentialStrengthPipe,
  FileListShowComponent,
  SeDepartmentViewComponent
];
const DIRECTIVES: Array<Type<any>> = [];
// #endregion


// #region your componets & directives
const PIPES = [ExponentialStrengthPipe];


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    AlainThemeModule.forChild(),
    DelonACLModule,
    DelonFormModule,
    ...SHARED_DELON_MODULES,
    ...SHARED_ZORRO_MODULES,
    // third libs
    ...THIRDMODULES
  ],
  declarations: [
    // your components
    ...COMPONENTS,
    ...DIRECTIVES,
    ...PIPES
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AlainThemeModule,
    DelonACLModule,
    DelonFormModule,
    TranslateModule,
    ...SHARED_DELON_MODULES,
    ...SHARED_ZORRO_MODULES,
    // third libs
    ...THIRDMODULES,
    // your components
    ...COMPONENTS,
    ...DIRECTIVES
  ]
})
export class SharedModule { }
